/** Short display label for a drawing page: the saved sheet name alone when
 *  the user renamed it (e.g. "P2"), otherwise "filename · Page N" so default
 *  names stay unambiguous across drawings. The full filename always lives in
 *  the row's tooltip (title=). */
export const isDefaultSheetName = (name, page) => !name || name.trim() === `Page ${page}`;
export const sheetLabel = (name, page, drawingName) =>
  isDefaultSheetName(name, page) ? `${drawingName} · Page ${page}` : name.trim();
